const BASE_URL: string = process.env.REACT_APP_API_BASE_URL || '';

export { BASE_URL as default, BASE_URL };
